import { render } from "./IncludeSelectionButton.vue?vue&type=template&id=3961ce14"
import script from "./IncludeSelectionButton.vue?vue&type=script&lang=js"
export * from "./IncludeSelectionButton.vue?vue&type=script&lang=js"

import "./IncludeSelectionButton.vue?vue&type=style&index=0&id=3961ce14&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__